import {createFeature, createReducer, on} from '@ngrx/store';
import {LoadCountyDataSuccess, LoadTerritoryDataSuccess} from './location.actions';
import {County} from '../../core/classes/county';
import { Territory } from '../../core/classes/territory';

export interface LocationState {
  territories: Territory[]
  counties: County[]
}

const initialState: LocationState = {
  territories: [],
  counties: [],
};

const locationFeature = createFeature({
  name: 'location',
  reducer: createReducer(
    initialState,
    on(LoadTerritoryDataSuccess, (state, {territories}) => ({
        ...state,
        territories: territories,
      }
    )),
    on(LoadCountyDataSuccess, (state, {counties}) => ({
        ...state,
        counties: counties,
      }
    )),
  ),
});

export const {
  name: locationFeatureKey,
  reducer: locationReducer,
  selectTerritories,
  selectCounties,
} = locationFeature;

